import type { ContextualFinding, RiskLevel } from "../global";

const RISK_PRIORITY: Record<RiskLevel, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
};

/**
 * Derives the highest risk level from an array of contextual findings.
 * Returns undefined if the array is empty.
 */
export function getHighestRiskLevel(findings: ContextualFinding[]): RiskLevel | undefined {
  if (findings.length === 0) return undefined;

  let highest: RiskLevel = findings[0].risk_level;
  for (const f of findings) {
    if ((RISK_PRIORITY[f.risk_level] ?? 4) < (RISK_PRIORITY[highest] ?? 4)) {
      highest = f.risk_level;
    }
  }
  return highest;
}
